import { FC } from "react"

import CloseIcon from "@mui/icons-material/Close"
import { Dialog, DialogTitle, DialogContent } from "@mui/material"

import { Button, Typography, Tooltip } from "@synapse-analytics/synapse-ui"

import styles from "./WarningDialog.module.scss"

interface Props {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  content?: string
  confirmationText?: string
  actionTitle?: string
  isDangerousAction?: boolean
  cancelTitle?: string
  dialogTitle?: string
  isLoading?: boolean
  shouldLockWhileLoading?: boolean
}

const WarningDialog: FC<Props> = ({
  onCancel,
  onConfirm,
  isOpen,
  dialogTitle,
  content,
  confirmationText,
  actionTitle,
  cancelTitle,
  isLoading,
  isDangerousAction,
  shouldLockWhileLoading,
}) => {
  const confirmationButtonVariant =
    isDangerousAction || actionTitle === "Delete" || confirmationText ? "dangerous" : "primary"

  const handleClose = () => {
    if (!isLoading || !shouldLockWhileLoading) {
      onCancel()
    }
  }

  return (
    <Dialog
      onClick={(event) => event.stopPropagation()}
      maxWidth="xs"
      open={isOpen}
      disableEscapeKeyDown
      onClose={handleClose}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-dialog-close-entity-creation"
      classes={{
        paper: styles.wrapper,
        root: styles.root,
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          padding: 0,
        }}
      >
        <div className={styles.header}>
          <Typography variant="h2-bold">{dialogTitle || "Warning"}</Typography>
          <Tooltip title={isLoading && shouldLockWhileLoading ? "Please wait, loading..." : ""}>
            <CloseIcon onClick={handleClose} className={styles.iconContainer} />
          </Tooltip>
        </div>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "10px 0px",
          paddingTop: "10px !important",
        }}
      >
        <Typography variant="p">
          {content || (confirmationText && `Are you sure you want to ${confirmationText}`)}
        </Typography>
      </DialogContent>
      <div className={styles.actionButton}>
        <Button onClick={onConfirm} variant={confirmationButtonVariant} fullWidth isLoading={isLoading}>
          {actionTitle || "Confirm"}
        </Button>
        <Button onClick={onCancel} variant="ghost" fullWidth>
          {cancelTitle || "Cancel"}
        </Button>
      </div>
    </Dialog>
  )
}
export default WarningDialog
